import { createFeature, createReducer, on } from '@ngrx/store';
import { createEntityAdapter } from '@ngrx/entity';
import {
    LoadBankAccountListAction,
    SetBankAccountListAction,
    ResetBankAccountListAction,
} from './bank-accounts.actions';
import {
    BankAccountsAdapter,
    BankAccountsEntityState,
} from '../../interfaces';

export const BankAccountsFeatureAdapter: BankAccountsAdapter =
    createEntityAdapter({
        selectId: (e) => e.id,
    });

const initialState: BankAccountsEntityState =
    BankAccountsFeatureAdapter.getInitialState({
        loaded: false,
    });

export const BankAccountsFeatureName = 'BankAccounts';

export const BankAccountsFeature = createFeature({
    name: BankAccountsFeatureName,
    reducer: createReducer(
        initialState,
        on(LoadBankAccountListAction, (state) => ({
            ...state,
            loaded: false,
        })),
        on(ResetBankAccountListAction, (state) =>
            BankAccountsFeatureAdapter.removeAll(state)
        ),
        on(SetBankAccountListAction, (state, { list }) =>
            BankAccountsFeatureAdapter.setAll(list, {
                ...state,
                loaded: true,
            })
        )
    ),
});
